/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.PublicBillingActionsRpc
 */
import * as References from './PublicBillingActionsRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import { restClient } from 'billing-portal-ui/js/clients/chirpClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: restClient
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.PublicBillingActionsRpc#getPaymentMethodUpdateRequestUrl
 */
export const GET_PAYMENT_METHOD_UPDATE_REQUEST_URL_QUERY_FIELD_NAME = 'com_hubspot_commerce_buyer_portal_rpc_PublicBillingActionsRpc_getPaymentMethodUpdateRequestUrl';
export const GET_PAYMENT_METHOD_UPDATE_REQUEST_URL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PAYMENT_METHOD_UPDATE_REQUEST_URL_QUERY_FIELD_NAME,
  args: ['crmSubscriptionId', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getPaymentMethodUpdateRequestUrlRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.PublicBillingActionsRpc#getInvoicePaymentInfo
 */
export const GET_INVOICE_PAYMENT_INFO_QUERY_FIELD_NAME = 'com_hubspot_commerce_buyer_portal_rpc_PublicBillingActionsRpc_getInvoicePaymentInfo';
export const GET_INVOICE_PAYMENT_INFO_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_INVOICE_PAYMENT_INFO_QUERY_FIELD_NAME,
  args: ['crmInvoiceId', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getInvoicePaymentInfoRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.PublicBillingActionsRpc#getReceiptEmailRecipients
 */
export const GET_RECEIPT_EMAIL_RECIPIENTS_QUERY_FIELD_NAME = 'com_hubspot_commerce_buyer_portal_rpc_PublicBillingActionsRpc_getReceiptEmailRecipients';
export const GET_RECEIPT_EMAIL_RECIPIENTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_RECEIPT_EMAIL_RECIPIENTS_QUERY_FIELD_NAME,
  args: ['commercePaymentCrmId', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getReceiptEmailRecipientsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.PublicBillingActionsRpc#resendReceiptEmail
 */
export const RESEND_RECEIPT_EMAIL_MUTATION_FIELD_NAME = 'com_hubspot_commerce_buyer_portal_rpc_PublicBillingActionsRpc_resendReceiptEmail';
export const RESEND_RECEIPT_EMAIL_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: RESEND_RECEIPT_EMAIL_MUTATION_FIELD_NAME,
  args: ['commercePaymentCrmId', 'toEmailAddress', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.resendReceiptEmailRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.PublicBillingActionsRpc#cancelSubscription
 */
export const CANCEL_SUBSCRIPTION_MUTATION_FIELD_NAME = 'com_hubspot_commerce_buyer_portal_rpc_PublicBillingActionsRpc_cancelSubscription';
export const CANCEL_SUBSCRIPTION_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CANCEL_SUBSCRIPTION_MUTATION_FIELD_NAME,
  args: ['crmSubscriptionId', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.cancelSubscriptionRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.PublicBillingActionsRpc#deletePaymentMethod
 */
export const DELETE_PAYMENT_METHOD_MUTATION_FIELD_NAME = 'com_hubspot_commerce_buyer_portal_rpc_PublicBillingActionsRpc_deletePaymentMethod';
export const DELETE_PAYMENT_METHOD_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_PAYMENT_METHOD_MUTATION_FIELD_NAME,
  args: ['paymentMethodId', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.deletePaymentMethodRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});